/**
 * 画像OCR NGワードチェックの表示用ユーティリティ。
 * NGワードの照合はAPI(getProductImages)側で済んでおり、ここでは表示の形に整えるだけ。
 */
import type { OcrNgHit, ProductImageOcr } from '@/types/api'
import { levelBucket, type NgLevelBucket } from '@/utils/ngHighlight'

/** サムネイルの番号右隣に出すバッジの内容 */
export type OcrBadgeState =
  | { kind: 'pending' } // 「OCR未」
  | { kind: 'clean' } // 「NGなし」
  | { kind: 'hits'; counts: { level: NgLevelBucket; count: number }[] } // レベル別件数
  | null // 表示しない(error / check_failed / 旧API)

export function ocrBadgeState(ocr: ProductImageOcr | undefined): OcrBadgeState {
  if (!ocr) return null
  if (ocr.status === 'pending') return { kind: 'pending' }
  if (ocr.status !== 'done') return null

  const hits = ocr.hits ?? []
  if (hits.length === 0) return { kind: 'clean' }

  // 件数 = その画像に含まれるNGワードの数(枠の数ではない)
  const c: Record<NgLevelBucket, number> = { 9: 0, 7: 0, 5: 0 }
  for (const h of hits) c[levelBucket(h.level)]++
  const counts = ([9, 7, 5] as NgLevelBucket[])
    .filter((lv) => c[lv] > 0)
    .map((lv) => ({ level: lv, count: c[lv] }))
  return { kind: 'hits', counts }
}

/** 枠表示・一覧表示の対象になるヒット(OCR済みのときだけ) */
export function ocrHits(ocr: ProductImageOcr | undefined): OcrNgHit[] {
  return ocr?.status === 'done' ? ocr.hits ?? [] : []
}

/** 既存のNGワード表示(NgWordPanel)と同じ 'lv9' / 'lv7' / 'lv5' のクラス名 */
export function levelClass(level: number): string {
  return `lv${levelBucket(level)}`
}
